import IsibuteDocumentComponent from "./IsibuteDocumentComponent";
import { documentComponentFromData } from "./DocumentComponentRegistry";

class IsibuteDocumentResumeContactHeader extends IsibuteDocumentComponent {
  constructor({
    id,
    contactHeaderChildren,
    unstyledContent,
    styling,
    ordinal,
    documentComponentType,
    parentDocumentComponentId,
    firstChildDocumentComponentId,
    lastChildDocumentComponentId,
    previousDocumentComponentId,
    nextDocumentComponentId,
    isibuteDocument,
  }) {
    super({
      id,
      unstyledContent,
      styling,
      ordinal,
      documentComponentType,
      parentDocumentComponentId,
      firstChildDocumentComponentId,
      lastChildDocumentComponentId,
      previousDocumentComponentId,
      nextDocumentComponentId,
      isibuteDocument,
    });

    this.contactHeaderChildren = {};

    if (contactHeaderChildren) {
      Object.entries(contactHeaderChildren).forEach(([key, value]) => {
        this.contactHeaderChildren[key] = documentComponentFromData({ ...value, isibuteDocument });
      });
    }
  }

  asJSON = () => {
    return {
      id: this.id,
      unstyledContent: this.unstyledContent,
      styling: this.styling,
      ordinal: this.ordinal,
      documentComponentType: this.documentComponentType,
      parentDocumentComponentId: this.parentDocumentComponentId,
      firstChildDocumentComponentId: this.firstChildDocumentComponentId,
      lastChildDocumentComponentId: this.lastChildDocumentComponentId,
      previousDocumentComponentId: this.previousDocumentComponentId,
      nextDocumentComponentId: this.nextDocumentComponentId,
      contactHeaderChildren: Object.values(this.contactHeaderChildren).map((documentComponent) => {
        return documentComponent.asJSON();
      }),
    }
  }

  deepCopy = () => {
    const copy = new this.constructor({
      id: this.id,
      unstyledContent: this.unstyledContent,
      styling: this.styling,
      ordinal: this.ordinal,
      documentComponentType: this.documentComponentType,
      parentDocumentComponentId: this.parentDocumentComponentId,
      firstChildDocumentComponentId: this.firstChildDocumentComponentId,
      lastChildDocumentComponentId: this.lastChildDocumentComponentId,
      previousDocumentComponentId: this.previousDocumentComponentId,
      nextDocumentComponentId: this.nextDocumentComponentId,
      isibuteDocument: this.isibuteDocument,
    });

    Object.entries(this.contactHeaderChildren).forEach(([key, value]) => {
      copy.contactHeaderChildren[key] = value.deepCopy();
    });

    return copy;
  };

  getDocumentComponentByKey = (key) => {
    return this.contactHeaderChildren[key] || null;
  };

  getDocumentComponentByKeyPath = ({ keyPath }) => {
    const [first, ...rest] = keyPath ?? [];
    const currentDocumentComponent = this.getDocumentComponentByKey(first);

    if (rest.length > 0) {
      return currentDocumentComponent?.getDocumentComponentByKeyPath({ keyPath: rest }) || null;
    }

    return currentDocumentComponent;
  };
};

export default IsibuteDocumentResumeContactHeader;
